<template>
  <nav class="tabbar" aria-label="底部主导航">
    <SeoLink
      v-for="(item, index) in tabbarList"
      :key="index"
      class="tabbar-item"
      :to="{ name: item.pathName }"
      :aria-current="activeIndex === index ? 'page' : null"
      :guard="event => change(index, item.pathName, event)"
    >
      <img :src="activeIndex == index ? item.active : item.inactive" alt="" />
      <span :style="activeIndex == index ? {color: '#1890ff' }: {color: '#262626'}">{{item.title}}</span>
    </SeoLink>
  </nav>
  <!-- <van-tabbar v-model="activeIndex" route>
    <van-tabbar-item replace to='/home'>
      <span>首页</span>
      <template #icon="props">
        <img :src="props.active ? icon[0].active : icon[0].inactive" />
      </template>
    </van-tabbar-item>
     <van-tabbar-item replace to='/intro'>
      <span>创建答题</span>
      <template #icon="props">
        <img :src="props.active ? icon[1].active : icon[1].inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace to='/questionList'>
      <template #icon="props">
        <img @click="change(0)" :src="props.active ? icon[2].active : icon[2].inactive" />
      </template>
      <span>我的答题</span>
    </van-tabbar-item>
  </van-tabbar> -->
</template>

<script>
import SeoLink from "@/components/SeoLink.vue";
export default {
  components: { SeoLink },
  props: {
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tabbarList: [
        {
          title: "首页",
          active: require("../assets/icon/tab_home_selected.png"),
          inactive: require("../assets/icon/tab_home_.png"),
          pathName: 'home'
        },
        {
          title: "创建答题",
          active: require("../assets/icon/tab_cj_sele.png"),
          inactive: require("../assets/icon/tab_cj.png"),
          pathName: 'intro',
        },
        {
          title: "我的答题",
          active: require("../assets/icon/tab_question_selected.png"),
          inactive: require("../assets/icon/tab_question.png"),
          pathName: 'questionList'
        },
        {
          title: "个人中心",
          active: require("../assets/icon/tab_me_sele.png"),
          inactive: require("../assets/icon/tab_me_.png"),
          pathName: 'personal'
        }
      ]
    };
  },
  methods: {
    change(val, pathName) {
      if(val === this.activeIndex) {
        return false;
      }
      if(val == 2) _hmt.push(["_trackEvent", "button_to_questionlist", "click", "我的答题"]);
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
nav {
  display: block;
}
.tabbar{
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  left: auto;
  bottom: 0;
  width: 100%;
  background: #ffffff;
  max-width: 500px;
  min-width: 320px;
  z-index: 99;
  &:after{
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    top: -50%;
    right: -50%;
    bottom: -50%;
    left: -50%;
    border: 1px solid #ebedf0;
    -webkit-transform: scale(.5);
    transform: scale(.5)
  }
}
.tabbar-item{
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: rem(100);
  font-size: rem(24);
  img{
    width: rem(48) !important;
    height: rem(48) !important;
    margin-top: rem(4);
    cursor: pointer;
  }
  span{
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footerTab.vue